module.exports = __webpack_public_path__ + "img/tab1.ab97f9e2.png";